(function ($) {
  'use strict';

  $(document).ready(function () {

//------- Bildwischer------ interact.js---------
    const paraBildwischer = $('.paragraph--type--bildwischer');
    if (paraBildwischer.length > 0) {
      interact('.resize-drag')
        .resizable({
          // resize from all edges and corners
          edges: {left: false, right: true, bottom: false, top: false},
          // keep the edges inside the parent
          restrictEdges: {
            outer: 'parent',
            endOnly: true
          },
          // minimum size
          restrictSize: {
            min: {width: 0}
          },
          inertia: true
        })
        .on('resizemove', function (event) {
          const target = event.target,
            x = (parseFloat(target.getAttribute('data-x')) || 0),
            y = (parseFloat(target.getAttribute('data-y')) || 0);

          // update the element's style
          target.style.width = event.rect.width + 'px';
        });
      if (paraBildwischer.length > 1) {
        paraBildwischer.each(function () {
          $('.prev_image').on('click', function () {
            const thisData = $(this).attr('data-prevImage');
            $(this).closest(paraBildwischer).find('.wrapper').css('display', 'none');
            $('.' + thisData).css('display', 'block');
          });
        });
      } else {
        $('.prev_image').on('click', function () {
          const thisData = $(this).attr('data-prevImage');
          $('.paragraph--type--bildwischer .wrapper').css('display', 'none');
          $('.' + thisData).css('display', 'block');
        })
      }
    }

  });// Document ready

})(jQuery);